import { BUILD_ID_STORE_KEY, HASH_ALPHABET } from './constants';

// Fetches a build name from localstorage
export const getBuildName = (guide: string): string | undefined => {
  try {
    const buildIds = JSON.parse(localStorage.getItem(BUILD_ID_STORE_KEY) || '{}');
    return buildIds[guide] as string;
  } catch (error) {
    return undefined;
  }
};

// Stores a build name into localstorage
export const storeBuildName = (guide: string, buildName: string): void => {
  try {
    const buildIds = JSON.parse(localStorage.getItem(BUILD_ID_STORE_KEY) || '{}');
    buildIds[guide] = buildName;
    localStorage.setItem(BUILD_ID_STORE_KEY, JSON.stringify(buildIds));
  } catch (error) {
    const buildIds = {
      [guide]: buildName,
    };
    localStorage.setItem(BUILD_ID_STORE_KEY, JSON.stringify(buildIds));
  }
};

// Generates a random string of X length using a predefined alphabet
const generateRandomHash = (length: number): string => {
  let hash = '';
  for (let i = 0; i < length; i += 1) {
    const randomIndex = Math.floor(Math.random() * HASH_ALPHABET.length);
    hash += HASH_ALPHABET[randomIndex];
  }
  return hash;
};

// Generates a build name
export const generateBuildName = (guide: string): string => {
  const uid = generateRandomHash(5);
  return `${guide}-build-${uid}`;
};
